import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

/** The signed-in user's display name from `profiles` (null when unset). */
export function useMyProfileName(userId: string | null | undefined) {
  return useQuery({
    queryKey: ['my-profile-name', userId],
    enabled: Boolean(userId),
    staleTime: 5 * 60_000,
    queryFn: async (): Promise<string | null> => {
      const { data, error } = await supabase
        .from('profiles')
        .select('name')
        .eq('id', userId!)
        .maybeSingle();
      if (error) return null;
      return (data?.name as string | null) ?? null;
    },
  });
}
